import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppThunk } from '@share/utils';
import { getHeaders, axiosInstance, getSelectedCurrency } from '@share/utils';
import { Urls } from '@share/constants';
import { ITopBookings } from '@common-types';

export interface ITopBookingsState {
  topProperties: ITopBookings;
  topDestinations: ITopBookings;
  loading: boolean;
  error: string;
}

const initialState: ITopBookingsState = {
  topProperties: null,
  topDestinations: null,
  loading: false,
  error: '',
};

const topBookingsSlice = createSlice({
  name: 'topBookings',
  initialState,
  reducers: {
    setLoading: (state: ITopBookingsState, { payload }: PayloadAction<boolean>) => {
      state.loading = payload;
    },
    setError: (state: ITopBookingsState, { payload }: PayloadAction<string>) => {
      state.error = payload;
    },
    setTopProperties: (state: ITopBookingsState, { payload }: PayloadAction<ITopBookings>) => {
      state.topProperties = payload;
    },
    setTopDestinations: (state: ITopBookingsState, { payload }: PayloadAction<ITopBookings>) => {
      state.topDestinations = payload;
    },
  },
});

export const topBookingsActions = topBookingsSlice.actions;
export const topBookingsReducer = topBookingsSlice.reducer;

export const getTopProperties = (account: any): AppThunk => {
  return async (dispatch) => {
    dispatch(topBookingsActions.setLoading(true));

    try {
      const url = '/deals/top';
      const res = await axiosInstance.get(`${url}/properties/${account.id}`, { ...getHeaders(), });
      dispatch(topBookingsActions.setTopProperties(res.data));
      dispatch(topBookingsActions.setLoading(false));
    } catch (error) {
      dispatch(topBookingsActions.setError(error.toString()));
      dispatch(topBookingsActions.setLoading(false));
    }
  };
};

export const getTopDestinations = (account: any): AppThunk => {
  return async (dispatch) => {
    dispatch(topBookingsActions.setLoading(true));

    try {
      const url = '/deals/top';
      const res = await axiosInstance.get(`${url}/destinations/${account.id}`, { ...getHeaders(), });
      dispatch(topBookingsActions.setTopDestinations(res.data));
      dispatch(topBookingsActions.setLoading(false));
    } catch (error) {
      dispatch(topBookingsActions.setError(error.toString()));
      dispatch(topBookingsActions.setLoading(false));
    }
  };
};
